export default __webpack_public_path__ + "static/media/Aegis-Cloud.332f7b41.svg";